import { configurationAdminOverrideSchema } from './configuration-admin-override.schema';
import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const configurationSettingSchema = z.object({
  settingId: z.number(),
  settingName: z.string().min(1),
  overrides: z.array(configurationAdminOverrideSchema).optional(),
  modifiedOn: coercedDate,
});

export type ConfigurationSetting = z.infer<typeof configurationSettingSchema>;
